<template>
		<input type="text" class="form-control" :value="value" @input="mask" />
</template>

<style scoped></style>
<script>
export default {
	props: ["value", "symbol", "format"],
	data() {
		return {
			decSep: ".",
			milSep: ",",
			prepend: "$ ",
			append: ""
		};
	},
	methods: {
		mask: function(e) {
			var input = e.target.value;
			var number = input.replace(/[^\d]/g, "");
			if (number.length) {
				number = (parseFloat(number) || 0) / 100;
				number = number.toFixed(2).replace(".", this.decSep);
				number = number.replace(/\B(?=(?:\d{3})+(?!\d))/g, this.milSep);

				input = this.prepend + number + this.append;
			}
			e.target.value=input;
			this.$emit("input", input);
		}
	},
	mounted() {

		if (this.format.match(/^\(symbol\)/)) {
			this.prepend = this.symbol + " ";
			this.append = "";
		}
		if (this.format.match(/\(symbol\)$/)) {
			this.append = " " + this.symbol;
			this.prepend = "";
		}
		var match = this.format.match(/\d([.,])\d\d\d([.,])\d\d/);
		if (match) {
			this.milSep = match[1];
			this.decSep = match[2];
		}

	}
};
</script>
